import * as types from '../mutation-types'
import { api } from '@/modules/api'
import * as R from 'ramda'

const state = {
  speakers: null,
  speakersHomepage: null,
  speakersPageSettings: {}
}

const getters = {
  getSpeakers: state => state.speakers,
  getPublishedSpeakers: state => {
    const speakers = state.speakers ? state.speakers : []
    return R.filter(R.propEq('status', 'Published'), speakers)
  },
  getHomepageSpeakers: state => state.speakersHomepage
}

const actions = {
  async fetchSpeakersList ({ commit }, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data: { speakers } } = await this.$axios.get(api.speakers.getSpeakersList(payload))
      commit(types.SET_SPEAKERS_LIST, speakers)
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to load speakers list')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async deleteSpeakerById ({ commit }, ids) {
    try {
      await this.$axios.delete(api.speakers.deleteSpeaker(ids))
      commit(types.CHANGE_SPEAKER_STATUS, { id: ids[0], newStatus: 'Deleted' })
      this.dispatch('showResultSuccessMessage', 'Deleted')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to delete speaker')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async draftSpeakerById ({ commit }, ids) {
    try {
      await this.$axios.patch(api.speakers.draftSpeaker(), { speakersIds: ids })
      commit(types.CHANGE_SPEAKER_STATUS, { id: ids[0], newStatus: 'Draft' })
      this.dispatch('showResultSuccessMessage', 'Changed')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to change speaker')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async publishSpeakerById ({ commit }, ids) {
    try {
      await this.$axios.patch(api.speakers.publishSpeaker(), { speakersIds: ids })
      commit(types.CHANGE_SPEAKER_STATUS, { id: ids[0], newStatus: 'Published' })
      this.dispatch('showResultSuccessMessage', 'Changed')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to change speaker')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async createSpeaker ({ commit }, payload) {
    try {
      await this.$axios.post(api.speakers.createEditSpeaker(), payload)
      commit(types.SAVE_CURRENT_SPEAKER, payload)
      this.dispatch('showResultSuccessMessage', 'Success')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to create or edit speaker')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editSpeaker ({ commit }, payload) {
    try {
      await this.$axios.put(api.speakers.createEditSpeaker(), payload)
      commit(types.SAVE_CURRENT_SPEAKER, payload)
      this.dispatch('showResultSuccessMessage', 'Success')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to create or edit speaker')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateSpeakersPageSettings ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.speakersSettings.updateSettings(), { ...payload })
      commit(types.CREATE_SUCCESS_MESSAGE, 'Page settings were updated successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Page settings were not updated')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async patchOrdersSpeaker ({ commit }, speakers) {
    try {
      await this.$axios.patch(api.speakers.patchOrdersSpeaker(), { speakers })
      this.dispatch('showResultSuccessMessage', 'Changed Order')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to Change Order of speakers')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async setSpeakersVisibleHomepage ({ commit }, speakerIds) {
    try {
      await this.$axios.patch(api.speakers.setSpeakersVisibleHomepage(), { speakerIds })
      this.dispatch('showResultSuccessMessage', 'Speakers saved')
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to save speakers')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchSpeakersVisibleHomepage ({ commit }, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const { data: { speakers } } = await this.$axios.get(api.speakers.fetchSpeakersVisibleHomepage(payload))
      commit(types.SET_SPEAKERS_HOMEPAGE_LIST, speakers)
    } catch (err) {
      this.dispatch('showResultErrorMessage', 'Failed to load speakers list')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }

}

const mutations = {
  [types.SET_SPEAKERS_LIST] (state, speakers) {
    state.speakers = [...speakers]
  },
  [types.SET_SPEAKERS_PAGE_SETTINGS] (state, settings) {
    state.speakersPageSettings = settings
  },
  [types.SAVE_CURRENT_SPEAKER] (state, speaker) {
    if (!speaker.id) {
      state.speakers.push(speaker)
    } else {
      for (let i in state.speakers) {
        if (state.speakers.id === speaker.id) {
          state.speakers[i] = speaker
        }
      }
    }
  },
  [types.CHANGE_SPEAKER_STATUS] (state, payload) {
    for (let i in state.speakers) {
      let currentSpeaker = state.speakers[i]
      if (currentSpeaker.id === payload.id) {
        if (payload.newStatus === 'Published') {
          currentSpeaker.status = 'Published'
        } else if (payload.newStatus === 'Draft') {
          currentSpeaker.status = 'Draft'
        } else {
          currentSpeaker.status = 'Deleted'
        }
        return
      }
    }
  },
  [types.SET_SPEAKER_SETTINGS] (state, payload) {
    state.speakersSettings = Object.assign({}, payload)
  },
  [types.SET_SPEAKERS_HOMEPAGE_LIST] (state, payload) {
    state.speakersHomepage = [...payload]
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/speakers.js